/* globals Promise */

import moment from 'moment';
import analyticsDataFetcherStore from 'zoomforth_zf/appglobals/analytics-fetcher-cacher.js';

export const DUMMY_EARLIEST_MOMENT = moment('1970-01-01T00:00:00Z');
export const DUMMY_EARLIEST_UTC_MOMENT = DUMMY_EARLIEST_MOMENT.utc();
const FLOOR_MODULO_MS = 1000 * 60 * 30;

/*
  Return a new moment js object rounded to the nearest,
  30 mins interval less than the given moment js object
  (i.e., a "floor" operation)
*/
export function floorMoment(momentToFloor, moduloMs=FLOOR_MODULO_MS) {
  return moment(momentToFloor - (momentToFloor % moduloMs));
}


export const fetchPageVisitCountByPageId = ()=>
  new Promise((resolve, reject)=> {
    var analyticsDataFetcher = analyticsDataFetcherStore.get();

    const siteVisitsCountById = analyticsDataFetcher
      .request()
      .sites_visits()
      .params({
        startDate: DUMMY_EARLIEST_MOMENT,
        endDate: floorMoment(moment()),
        extra_filters: {
          shouldIgnoreZfUsers: true
        }
      })
      .group_by(['lens.id'])
      .count();

    siteVisitsCountById
      .then(({ data }) => {
        resolve(data);
      })
      .fail(reject);
  });
